import { Color } from "../../../core/models/entities/LogoOptions";
import ColorBlockWithToolTip from "../../screens/logo-editor/componenets/ColorBlockWithToolTip";

interface Props {
  color: Color;
  showName?: boolean;
  maxWidth?: string;
}

export function VectorColorElement({ color, showName, maxWidth = "max-w-16" }: Props) {
  return (
    <div className={"flex align-middle space-x-1"}>
      <ColorBlockWithToolTip onClick={() => {}} size={"sm"} color={color} />
      {showName && (
        <span className={`truncate ${maxWidth}`}>
          {color.name === "Sort"
            ? "Black"
            : color.name === "Hvid"
            ? color.isBackup
              ? "Backup White"
              : "White"
            : color.name}
        </span>
      )}
    </div>
  );
}
